import type { SVGProps } from "react";

export type DropdownIconProps = SVGProps<SVGSVGElement>;

const CHEVRON_PATH =
  "M5.20710678,0.207106781 C5.48324916,0.483249156 5.48324916,0.930964406 5.20710678,1.20710678 L1.707,4.707 L5.20710678,8.20710678 C5.48324916,8.48324916 5.48324916,8.93096441 5.20710678,9.20710678 C4.93096441,9.48324916 4.48324916,9.48324916 4.20710678,9.20710678 L0.207106781,5.20710678 C-0.0690355937,4.93096441 -0.0690355937,4.48324916 0.207106781,4.20710678 L4.20710678,0.207106781 C4.48324916,-0.0690355937 4.93096441,-0.0690355937 5.20710678,0.207106781 Z";

/** 导航下拉箭头图标，默认 12×12，颜色继承 `currentColor` */
export function DropdownIcon({
  width = 12,
  height = 12,
  className,
  ...props
}: DropdownIconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
      {...props}
    >
      <g transform="translate(6 6) rotate(90) translate(-6 -6) translate(3.2929 1.2929)">
        <path fill="currentColor" d={CHEVRON_PATH} />
      </g>
    </svg>
  );
}
